import { render } from "./contentView.vue?vue&type=template&id=e5089212&scoped=true"
const script = {}

import "./contentView.vue?vue&type=style&index=0&id=e5089212&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5089212"]])

export default __exports__